import React from 'react';
import { Icon } from './Icon.js';
export const IconLock = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 10V6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6V10", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 10H21V21H3V10Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 15V16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLock.js.map